export default {"src":"/_next/static/media/user.afabf1a9.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};